var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 10,
    viewBox: "0 0 57 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4243 5.42426C56.6586 5.18995 56.6586 4.81005 56.4243 4.57574L52.6059 0.757359C52.3716 0.523045 51.9917 0.523045 51.7574 0.757359C51.523 0.991674 51.523 1.37157 51.7574 1.60589L55.1515 5L51.7574 8.39411C51.523 8.62843 51.523 9.00833 51.7574 9.24264C51.9917 9.47696 52.3716 9.47696 52.6059 9.24264L56.4243 5.42426ZM0 5.6H1.27273V4.4H0V5.6ZM3.81818 5.6H6.36364V4.4H3.81818V5.6ZM8.90909 5.6H11.4545V4.4H8.90909V5.6ZM14 5.6H16.5455V4.4H14V5.6ZM19.0909 5.6H21.6364V4.4H19.0909V5.6ZM24.1818 5.6H26.7273V4.4H24.1818V5.6ZM29.2727 5.6H31.8182V4.4H29.2727V5.6ZM34.3636 5.6H36.9091V4.4H34.3636V5.6ZM39.4545 5.6H42V4.4H39.4545V5.6ZM44.5455 5.6H47.0909V4.4H44.5455V5.6ZM49.6364 5.6H52.1818V4.4H49.6364V5.6ZM54.7273 5.6H56V4.4H54.7273V5.6Z",
    fill: "#969696",
    fillOpacity: 0.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a6612c7cc2667adc07d5a21341bcadc6.svg";
export { ForwardRef as ReactComponent };